import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-about',
  templateUrl: './new-about.component.html',
  styleUrls: ['./new-about.component.scss'],
        encapsulation: ViewEncapsulation.None
})
export class NewAboutComponent implements OnInit {

  public ads: any[] = [];

  

product: any = {
  title: '',
  content: '',
};


  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
       private apiService: ApisService,
        private toastr: ToastrService,
                 private translate: TranslateService
  ) {} 
    productId: string | null = null;

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;

  public tempData = [];
  vision: any = null;
  goals: any = null;
  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

ngOnInit(): void {
    // Fetch 
    this.apisService.Nabout().subscribe({
      next: (response: any) => {
        this.vision = response.data || {};
        console.log('Vision:', this.vision);
      },
      error: (err) => {
        console.error('Error fetching vision:', err);
      }
    });


  }

 

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.ads = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


updateProduct(): void {
  if (!this.vision?.id) {
    this.toastr.error('Missing record ID');
    return;
  }

  const data = {
    id: this.vision.id, // ✅ include ID here
    title_ar: this.vision.title_ar || '',
    title_en: this.vision.title_en || '',
    content_ar: this.vision.content_ar || '',
    content_en: this.vision.content_en || ''
  };

this.apiService.editNabout(data).subscribe({
  next: () => {
    this.toastr.success(
      this.translate.instant('MENU.DASHBOARD.record_updated_successfully')
    );
  },
  error: (err) => {
    console.error('Update failed:', err);
    this.toastr.error(
      this.translate.instant('MENU.DASHBOARD.failed_to_update_record')
    );
  },
});

}




}
